import { Injectable } from "@angular/core";
import {
  Router,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
} from "@angular/router";
import { AuthenticationService } from "../../services/auth.service";

@Injectable({ providedIn: "root" })
export class AuthGuard {
  constructor(
    private router: Router,
    private authService: AuthenticationService,
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
  ): boolean {
    const user = this.authService.currentUser();

    // Not logged in
    if (!user) {
      this.router.navigateByUrl("/authentication");
      return false;
    }

    const allowedUserTypes = route.data?.["userTypes"] as number[] | undefined;

    // User type not allowed
    if (allowedUserTypes && !allowedUserTypes.includes(user.userType)) {
      this.authService.redirectAfterLogin(user);
      return false;
    }

    const collegeUserTypes = [3, 5, 6, 7, 8];

    // Handle userType 8 (College Admin)
    if (collegeUserTypes.includes(user.userType)) {
      // If IsTenant is false, redirect to complete profile
      if (user.isTenant === false || user.isTenant === "false") {
        // Allow access to complete-profile route
        if (state.url === "/authentication/complete-profile") {
          return true;
        }
        // Redirect to complete profile
        this.router.navigate(["/authentication/complete-profile"]);
        return false;
      }

      // If IsTenant is true, user should be on college admin dashboard
      // Prevent access to complete-profile page
      if (state.url === "/authentication/complete-profile") {
        this.router.navigate(["/college-admin-dashboard/welcome"]);
        return false;
      }
    }

    return true;
  }
}
